module.exports = __webpack_public_path__ + "static/media/dialog.bd8e79ee.png";